import type { IPlanDecoration } from 'models/plan-decoration.model'
import type { IPlanRaw } from 'models/plan.model'

export const getDefaultPlan = (
  plans: IPlanRaw[],
  decorations: IPlanDecoration[],
): IPlanRaw | null =>
  plans.find((p) => decorations.find((d) => d.name === p.name)?.isDefault) ||
  plans[0] ||
  null
